/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IReferencias from 'Infotrack@Modelos/smartStock/referencias/entidades/referencias';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import ReferenciasCM from '../controladorModelo/referenciasCM';
import { acciones, IEstadoReferencias } from '../reductorReferencias';
import ReferenciasVista from '../vista/tablaReferenciasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const referenciasCM = new ReferenciasCM();

const TableReferenciasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [referenciass, setReferenciass] = React.useState<IReferencias[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoReferencias>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarReferencias();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarReferencias = () => {
        manejadorIndicadorCargaGlobal(true);
        referenciasCM.consultarReferenciasPorFiltro({EmpresaId:idEmpresa}).then((referenciass) => {
            setReferenciass(referenciass);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadReferencias?: IReferencias) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadReferencias, tipoFormulario } });
    };

    const confirmarEliminacion = (referencias: IReferencias) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarReferencias(referencias),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarReferencias = (referencias: IReferencias) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        referenciasCM.eliminarReferencias(referencias).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ReferenciasVista
            referenciass={referenciass}
            cargarReferencias={cargarReferencias}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableReferenciasCV;
